// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__i8Qfr","tooltip":"styles_tooltip__I2glq"};